import {css} from 'styled-components';
import Theme from '../Theme';

export default css`
  /* #rev-GlobalSpinner {
  } */

  #rev-ProductListPage .rev-FilterMenuL2,
  #rev-ProductDetailPage .rev-FilterMenuL2 {
    position: sticky;
    top: 72px;
    margin: 0px 10px;

    & > .header {
      padding: 23px 0px;
      font-size: 1.25rem;

      & > .label {
        display: none;
      }

      &::before {
        content: '產品列表';
        flex: 1;
        font-size: 1.3rem;
      }
    }

    & > .L1 {
      background-color: transparent;
      border-radius: 0px;
      padding: 0px;
      margin-bottom: 0px;
      box-shadow: none;

      & > .header {
        padding: 10px 0;
        border-top: 1px solid #d0d0d0;
        font-size: 1rem;
        color: #000000;
      }

      & > .L1-items {
        border-top: 1px solid #d0d0d0;
        padding-left: 15px;
        overflow: hidden;

        & > .L2 {
          padding: 5px 10px;
        }

        & > .L2 > .header {
          font-size: 0.95rem;
          color: #6f6f6f;
        }

        & > .L2.selected > .header {
          font-size: 0.95rem;
          color: var(--primaryColor);
        }
      }

      &:last-child {
        border-bottom: 1px solid #d0d0d0;
      }
    }
  }

  /* $$__CODEGEN_EXTRA_STYLEDCSS__$$ */

  .tda-header {
    border-bottom: 2px solid var(--primaryColor);
    display: flex;
    padding: 15px 0;
    margin-bottom: 25px;
    & > h2 {
      flex: 1;
      color: var(--primaryColor);
    }

    &.third-color {
      border-bottom-color: var(--thirdColor);
      & > h2 {
        color: var(--thirdColor);
      }
    }

    @media (max-width: ${Theme.breakpoint}px) {
      flex-direction: column-reverse;
    }
  }

  .tda-detail-title {
    border-bottom: solid 2px #ccc;
    padding-bottom: 15px;
    margin-bottom: 25px;
    & > h1 {
    }
    & > .category {
      color: var(--primaryColor);
    }
  }

  & main.tda-layout {
    max-width: var(--contentMaxWidth);
    margin: 0px auto;
    padding: 20px 0;
    display: flex;
    align-items: flex-start;
    gap: 30px;

    & > .nav {
      width: 240px;
    }

    & > .content {
      flex: 1;
      min-height: 300px;
      background-color: white;
      padding: 0 30px 30px 30px;
      border-radius: 6px;
      overflow: hidden;
    }

    @media (max-width: ${Theme.maxWidth}px) {
      padding: 20px;
    }

    @media (max-width: ${Theme.breakpoint}px) {
      padding: 15px;
      flex-direction: column;
      align-items: stretch;

      & .nav {
        width: 100%;

        h2 {
          text-align: center;
        }

        ul {
          white-space: nowrap;
          overflow-x: auto;
          overflow-y: hidden;
        }

        li {
          display: inline-block;
          svg {
            transform: rotate(90deg);
          }
        }
      }
      & > .content {
        padding: 0 15px 15px 15px;
      }
    }
  }

  & .tda-table {
    & .row {
      display: flex;
      border-bottom: solid 1px var(--thirdThBorderColor);

      &:first-child {
        border-top: solid 1px var(--thirdThBorderColor);
      }

      & > label {
        padding: 10px 5px;
        display: inline-block;
        color: var(primaryColor);
        font-weight: 500;
        flex: 0 0 120px;
        background-color: var(--thirdLightColor);
        color: var(--thirdColor);
      }
      & > .value {
        flex: 1;
        padding: 10px 5px;
      }
    }

    .inner-table {
      flex: 1;
      > .row:last-child {
        border-bottom: none;
      }
      > .row:first-child {
        border-top: none;
      }
      > .row:nth-child(2n) > .value {
        background-color: #fbfbfb;
      }
    }

    @media (max-width: ${Theme.breakpoint}px) {
      & .inner-table > .row {
        flex-direction: column;

        & > label {
          flex-basis: auto;
        }
      }
    }
  }

  .ant-table-thead {
    & > tr > th {
      color: var(--thirdColor);
      padding: 4px 16px;
      background-color: var(--thirdLightColor);
      border-bottom: solid 2px var(--thirdThBorderColor);
    }
  }

  .ant-table-tbody > tr.ant-table-row-selected:hover > td {
    background-color: var(--thirdThBorderColor);
  }
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background-color: var(--thirdLightColor);
  }

  .tda-list {
    list-style: none;
    padding: 0;
    margin: 0;
    & > li {
      display: flex;
      align-items: row;

      &:nth-child(2n) {
        background-color: #f5f5f5;
      }

      &:hover {
        background-color: var(--primaryColor);
        color: white;
      }
    }
  }

  & button.tda-form-button {
    background-color: var(--primaryColor);
    color: white;
    border: 0;
    height: 50px;
    border-radius: 10px;
    padding: 0 20px;
    cursor: pointer;
    align-self: flex-end;
  }
  & button.tda-form-button:disabled {
    background-color: var(--disabledBg);
    cursor: not-allowed;
  }

  & .tda-form-error-list {
    margin-top: 20px;
    h4::before {
      display: inline-block;
      margin-right: 4px;
      color: #ff4d4f;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
    }
    ul {
      padding: 0 0 0 22px;
    }
  }
`;
